import { render, staticRenderFns } from "./AddRemoveItem.vue?vue&type=template&id=3394aa1c"
import script from "./AddRemoveItem.vue?vue&type=script&lang=js"
export * from "./AddRemoveItem.vue?vue&type=script&lang=js"
import style0 from "./AddRemoveItem.vue?vue&type=style&index=0&id=3394aa1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports